<route>
  {
    "meta": {
      "permission": [
        "base_config.view_origins"
      ]
    }
  }
</route>

<template>
  <v-container fluid>
    <dialorigin v-model="dialog" :to-edit="toEdit" @done="reload = true" />
    <i-table
      :title="$t('customer_origin')"
      :headers="headers"
      app="base_config.origins"
      api="customerOrigin"
      :reload.sync="reload"
      @click:create="open()"
      @click:edit="open($event)"
    >
      <template v-slot:[`item.name`]="{ item }">
        {{ translateOrigin(item.name) }}
      </template>
    </i-table>
  </v-container>
</template>
<script>
import { mapGetters } from 'vuex'
import dialorigin from '../../components/customerOrigin/modal.vue'
export default {
  components: {
    dialorigin
  },
  created() {
    if (this.$store.getters['utils/getIsloading']) {
      this.$store.dispatch('utils/actionLoading')
    }
  },
  data() {
    return {
      reload: false,
      dialog: false,
      toEdit: null
    }
  },
  computed: {
    ...mapGetters({
      getPermissions: 'session/getPermissions',
      isAdmin: 'session/isAdmin'
    }),
    headers() {
      return [
        {
          text: this.$t('name'),
          value: 'name'
        },
        {
          text: this.$t('description'),
          value: 'description'
        },
        {
          align: 'center',
          text: this.checkPermissions.editOrDelete ? this.$t('action') : '',
          value: this.checkPermissions.editOrDelete ? 'actions' : '',
          width: '160px'
        }
      ]
    },
    /**
     * Determina si el usuario tiene los permisos necesarios según la indicación
     *
     * @return {boolean}
     *
     * @author Angelo Osorio <danielking.321 at gmail.com>
     */
    checkPermissions() {
      return {
        editOrDelete:
          this.getPermissions([`base_config.delete_origins`]) ||
          this.getPermissions([`base_config.change_origins`]) ||
          this.isAdmin
      }
    }
  },
  methods: {
    open(item) {
      this.toEdit = item === undefined ? null : item
      this.dialog = true
    },
    /**
     * Traduce el nombre del origen si existe una traducción disponible
     *
     * @param {string} name
     * @return {string}
     */
    translateOrigin(name) {
      if (!name) return ''
      const key = name.toLowerCase().replace(/ /g, '_').replace(/-/g, '_')
      const translated = this.$tc(key, 1)
      return translated === key ? name : translated
    }
  }
}
</script>
